exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vehicle-mini-item[data-v-45974688]{padding:10px;background:#fff;border-radius:8px;transition:background .2s}.vehicle-mini-item[data-v-45974688]:hover{background:#f1f3f5}.vehicle-avatar[data-v-45974688]{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center}.bg-light-primary[data-v-45974688]{background-color:#e9ecef!important;color:#3b82f6!important}.bg-light-danger[data-v-45974688]{background-color:#fee2e2!important;color:#ef4444!important}.vehicle-link[data-v-45974688]{text-decoration:none;cursor:pointer}.vehicle-link[data-v-45974688]:hover{text-decoration:underline!important}.xs-font[data-v-45974688]{font-size:.65rem;letter-spacing:.08em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45974688","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/VehicleMiniList.vue
// module id = 1549
// module chunks = 0